import { render, staticRenderFns } from "./warePositionBatchAdd.vue?vue&type=template&id=b8ae38ca&scoped=true&"
import script from "./warePositionBatchAdd.vue?vue&type=script&lang=js&"
export * from "./warePositionBatchAdd.vue?vue&type=script&lang=js&"
import style0 from "./warePositionBatchAdd.vue?vue&type=style&index=0&id=b8ae38ca&lang=less&scoped=true&"
import style1 from "./warePositionBatchAdd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ae38ca",
  null
  
)

component.options.__file = "warePositionBatchAdd.vue"
export default component.exports